import { Action, Reducer, State } from '../use_candidate_profile';
import { Status, StatusType } from '../actions/status_actions';

export const statusReducer: Reducer = (state: State, action: Action) => {
  switch (action.type) {
    case 'setStatus':
      const { key, ...payload } = action.payload;
      const newStatus: Status = {
        ...state.status,
      };
      newStatus[key as keyof Status] = payload as StatusType;
      return {
        ...state,
        status: newStatus,
      };
    default:
      return state;
  }
};
